export interface IFlow {
	flowName: string;
	stepName: string;
	stepLevel: number;
}

/**
 * Class for handling user flow events.
 */
export default class FlowHandler {
	public flows: Array<IFlow> = [];

	/**
	 * Get a user flow by name.
	 *
	 * @param flowName
	 */
	public getFlow(flowName: string): IFlow {
		return this.flows.find(f => f.flowName == flowName);
	}
	/**
	 * Create a new flow.
	 *
	 * @param flowName
	 * @param stepName
	 * @param stepLevel
	 */
	public createFlow(flowName: string, stepName: string, stepLevel: number): void {
		const flow = this.flows.find(f => f.flowName == flowName);
		if (flow === undefined) {
			const newFlow: IFlow = {
				flowName: flowName,
				stepName: stepName,
				stepLevel: stepLevel
			};
			this.flows.push(newFlow);
		}
	}

	/**
	 * Update a flow.
	 *
	 * @param flowName
	 * @param stepName
	 * @param stepLevel
	 */
	public updateFlow(flowName: string, stepName: string, stepLevel: number): void {
		const flowIndex = this.flows.map(f => f.flowName).indexOf(flowName);
		if (flowIndex === -1) {
			this.createFlow(flowName, stepName, stepLevel);
		} else {
			this.flows[flowIndex] = {
				flowName: flowName,
				stepName: stepName,
				stepLevel: stepLevel
			};
		}
	}

	/**
	 * Delete a flow.
	 *
	 * @param flowName
	 */
	public deleteFlow(flowName: string): void {
		const flowIndex = this.flows.map(f => f.flowName).indexOf(flowName);
		if (flowIndex !== -1) {
			this.flows.splice(flowIndex, 1);
		}
	}
}
